function SelectBank(bankOptions, bank){
  // Verifica se o banco selecionado existe.
  //console.log(bank)
  let INFORMATION = bankOptions.filter(item => item.bank_name === bank)[0]  
  if (INFORMATION) {
    let DATA_BANK_ELEMENTS = document.querySelectorAll('[data-bank-str]');   
    DATA_BANK_ELEMENTS.forEach((el) => {
      let STR = el.getAttribute('data-bank-str');   
      if (INFORMATION[STR]) {
        el.setAttribute("value", (INFORMATION[STR]));
      }
    });
  }
}

export function getStrBank(bankOptions, bank, str) {  
  let INFORMATION = bankOptions.filter(item => item.bank_name === bank)[0]
  if (INFORMATION[str]) {
    return INFORMATION[str];
  }else{
    throw new Error("The requested bank info was not found.");
  }
}

export default SelectBank;
